import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

/**
 * Displays a season standings table
 *
 * @param {Object} props
 * @param {Array} props.data - Array of standings data with rank, player, prize, record
 * @param {string} props.highlightUserId - User ID to highlight in the table
 */
export default function StandingsTable({ data = [], highlightUserId }) {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Standings
      </Typography>
      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table aria-label="season leaderboard">
          <TableHead>
            <TableRow sx={{ backgroundColor: "primary.main" }}>
              <TableCell>Rank</TableCell>
              <TableCell>Player</TableCell>
              <TableCell>Prize</TableCell>
              <TableCell>Record</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => {
              const isHighlighted =
                highlightUserId && row.userId === highlightUserId;
              return (
                <TableRow
                  key={`standings-${row.rank}`}
                  sx={{
                    backgroundColor: isHighlighted
                      ? "rgba(25, 118, 210, 0.1)"
                      : "inherit",
                    "&:hover": {
                      backgroundColor: isHighlighted
                        ? "rgba(25, 118, 210, 0.2)"
                        : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      fontWeight:
                        row.rank === 1 || isHighlighted ? "bold" : "normal",
                    }}
                  >
                    {row.rank}
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: isHighlighted ? "bold" : "normal" }}
                  >
                    {row.username}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "success.main",
                    }}
                  >
                    {row.winnings ? row.winnings : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: isHighlighted ? "bold" : "normal" }}
                  >
                    {`${row.wins}-${row.loses}`}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
